import { useLocation, Redirect } from "react-router-dom";

import PageLayout from "examples/LayoutContainers/PageLayout";
import Footer from "examples/Footer";

import checkExpiredToken from "helpers/checkExpiredToken";

import ServiceOrder from "./components/ServiceOrder";

function ListSupport() {
  return (
    <PageLayout>
      <ServiceOrder />
    </PageLayout>
  );
}

function CheckLogin() {
  const location = useLocation();
  const isLogged = checkExpiredToken();
  return isLogged ? (
    <ListSupport />
  ) : (
    <Redirect
      to={
        "/login?redirect=" +
        location.pathname +
        (location.search !== "" ? `${location.search}` : "")
      }
    />
  );
}

export default CheckLogin;
